import React from "react";
import { useTable } from "../../Components/useTable";

const WithdrawalsReportList = () => {
  const type = "Withdrawals Report";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "reason", numeric: false, label: "Reson" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "userName", numeric: false, label: "Name" },
    { id: "userEmail", numeric: false, label: "Email" },
    { id: "picture", numeric: false, label: "Picture" },
    { id: "usercode", numeric: false, label: "RID" },
    { id: "transactionstatus", numeric: false, label: "Status" },
    { id: "transactionamount", numeric: false, label: "Amount" },
    { id: "transactiondeductedTax", numeric: false, label: "Deduction Tax" },
    {
      id: "transactionoriginalAmount",
      numeric: false,
      label: "Original Amount",
    },
    { id: "transactioncreated", numeric: false, label: "Transaction Date" },
    { id: "transactionsubmitAt", numeric: false, label: "Submitted" },
    { id: "user_payment_methodid", numeric: false, label: "RID" },
    { id: "user_payment_methodtype", numeric: false, label: "Type" },
    { id: "user_payment_methodname", numeric: false, label: "Name" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default WithdrawalsReportList;
